import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'opener'

export default function OpenerPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Which kind of opener feels most you?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.opener.heading')}
      buttons={[
        {
          text: `❓ ${t('pages.onboarding.opener.options.karaokeSong')}`,
          value: 'karaokeSong',
        },
        {
          text: `❤️ ${t('pages.onboarding.opener.options.kindVibe')}`,
          value: 'kindVibe',
        },
        {
          text: `😄 ${t('pages.onboarding.opener.options.wokeUpLook')}`,
          value: 'wokeUpLook',
        },
        {
          text: `🌌 ${t('pages.onboarding.opener.options.emojiConstellation')}`,
          value: 'emojiConstellation',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
